// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1990":"cdd077e9","5628":"b7e5455c","6320":"b7e5455c","6542":"31d6cfe0","9355":"a4811393"}[chunkId] + ".chunk.css";
};